// src/offices.ts
import { EStudentImportAttributeFieldNames } from "platform-types";
import { importStudentFields } from "platform-data";
var tuitionKey = EStudentImportAttributeFieldNames.TUITION_DEPOSIT;
var tuitionFieldName = importStudentFields[tuitionKey].name;
var officeSelectionFields = Object.entries(importStudentFields).map(
  ([fieldName, field]) => {
    return {
      label: field.label,
      summaryField: field.summaryField,
      value: fieldName === tuitionKey ? tuitionFieldName || "" : fieldName
    };
  }
);

// src/config.ts
function deepFreeze(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var universityKeys = deepFreeze([
  { key: "UoG", name: "University of Greenwich" },
  { key: "USW", name: "University of South Wales" },
  { key: "ARU", name: "Anglia Ruskin University" },
  { key: "BCU", name: "Birmingham City University" },
  { key: "STR", name: "University of Strathclyde" }
]);
var SHARE_CODE_EXPIRY_DAYS_DEFAULT = 90;
var SHARE_CODE_EXPIRY_ALERT_DAYS_DEFAULT = 14;

// src/messages.ts
var defaultnoRoleAssignedMsg = "You do not have CAS Shield access level configured. Please contact your administrator.";

// src/uni-config.ts
import { CoreStatus, CoreStatusExtended } from "platform-types";

// src/uni-config-formatTypes.ts
function deepFreeze2(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze2(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultFormatTypes = deepFreeze2([
  {
    display: "Date (A valid moment date format)",
    shieldFormat: "YYYY-MM-DD",
    type: "MOMENT_DATE",
    uniFormat: "MOMENT_DATE"
  },
  {
    type: "DATE",
    uniFormat: "D.M.YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD.MM.YYYY"
  },
  {
    type: "DATE2",
    uniFormat: "D-M-YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD-MM-YYYY"
  },
  {
    type: "DATE3",
    uniFormat: "D-MMM-YY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD-MMM-YY"
  },
  {
    type: "DATE6",
    uniFormat: "D-MMM-YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD-MMM-YYYY"
  },
  {
    type: "DATE7",
    uniFormat: "D/M/YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "DD/MM/YYYY"
  },
  {
    type: "DATE8",
    uniFormat: "YYYY-MM-DDThh:mm:ss",
    shieldFormat: "YYYY-MM-DD",
    display: "YYYY-MM-DDThh:mm:ss"
  },
  {
    type: "DATE9",
    uniFormat: "MMM D, YYYY",
    shieldFormat: "YYYY-MM-DD",
    display: "MMM DD, YYYY"
  },
  {
    type: "MAP",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "BOOLEAN",
    display: "MAP (return as boolean)"
  },
  {
    type: "MAP2",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT",
    display: "MAP (return as string)"
  },
  {
    type: "MAP3",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "NUMBER",
    display: "MAP (return as number)"
  },
  {
    type: "GENDER",
    uniFormat: {
      male: "M",
      female: "F",
      other: "O"
    },
    shieldFormat: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    display: "Gender - single character (M or F or O)"
  },
  {
    type: "GENDER2",
    uniFormat: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    shieldFormat: {
      male: "Male",
      female: "Female",
      other: "Other"
    },
    display: "Gender - (Male / Female / Other)"
  },
  {
    type: "TEXT",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "Text"
  },
  {
    type: "TEXT_OR_BLANK",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT_OR_BLANK",
    display: "Text OR Blank"
  },
  {
    type: "TRUE_OR_FALSE",
    uniFormat: {
      true: "TRUE",
      false: "FALSE"
    },
    shieldFormat: {
      true: true,
      false: false
    },
    display: "TRUE or FALSE"
  },
  {
    type: "Y_OR_N",
    uniFormat: {
      true: "Y",
      false: "N"
    },
    shieldFormat: {
      true: true,
      false: false
    },
    display: "Single character (Y or N)"
  },
  {
    type: "YES_OR_NO",
    uniFormat: {
      true: "Yes",
      false: "No"
    },
    shieldFormat: {
      true: true,
      false: false
    },
    display: '"Yes" or "No"'
  },
  {
    type: "NUMBER",
    uniFormat: "TEXT",
    shieldFormat: "NUMBER",
    display: "Number"
  },
  {
    type: "ABS_NUMBER",
    uniFormat: "TEXT",
    shieldFormat: "ABS_NUMBER",
    display: "Absolute Number (Positive)"
  },
  {
    type: "ISO-3166-1 ALPHA-2 (Nationality)",
    uniFormat: "ISO-3166-1 ALPHA-2 (Nationality)",
    shieldFormat: "ISO-3166-1 ALPHA-2 (Nationality)"
  },
  {
    type: "ISO-3166-1 ALPHA-3 (Nationality)",
    uniFormat: "ISO-3166-1 ALPHA-3 (Nationality)",
    shieldFormat: "ISO-3166-1 ALPHA-3 (Nationality)"
  },
  {
    type: "ISO-3166-1 ALPHA-2 (Country)",
    uniFormat: "ISO-3166-1 ALPHA-2 (Country)",
    shieldFormat: "ISO-3166-1 ALPHA-2 (Country)"
  },
  {
    type: "ISO-3166-1 ALPHA-3 (Country)",
    uniFormat: "ISO-3166-1 ALPHA-3 (Country)",
    shieldFormat: "ISO-3166-1 ALPHA-3 (Country)"
  },
  {
    type: "REGEX",
    uniFormat: "TEXT",
    shieldFormat: "NUMBER",
    display: "Regex (return as number)"
  },
  {
    type: "REGEX2",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "Regex (return as text)"
  },
  {
    type: "REGEX3",
    uniFormat: "TEXT",
    shieldFormat: "BOOLEAN",
    display: "Regex (return as boolean)"
  },
  {
    type: "PADZERO8",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "8 Chars - Padded with 0"
  },
  {
    type: "PADZERO9",
    uniFormat: "TEXT",
    shieldFormat: "TEXT",
    display: "9 Chars - Padded with 0"
  },
  {
    type: "BLANK_IF_REGEX_CONDITION",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT_OR_BLANK",
    display: "Blank if regex condition returns a value"
  },
  {
    type: "DEFAULT_IF_REGEX_CONDITION",
    uniFormat: "TEXT_OR_BLANK",
    shieldFormat: "TEXT_OR_BLANK",
    display: "Default if regex condition returns a value"
  },
  {
    type: "MULTI_COLUMN",
    uniFormat: "MULTI_COLUMN",
    shieldFormat: "MULTI_COLUMN",
    display: "Multi-column selection (concatenated)"
  }
]);

// src/uni-config-fieldMappings.ts
function deepFreeze3(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze3(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultFieldMappings = deepFreeze3({
  intakeId: {
    uniField: "INTAKE_ID",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offerId: {
    uniField: "OFFER_ID",
    format: "MAP2",
    mappingType: "MAP_OFFER_ID_UNKNOWN",
    validationType: "STRING",
    setup: "Mandatory"
  },
  email: {
    uniField: "GOREMAL_EMAIL_ADDRESS",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  studentNo: {
    uniField: "SPRIDEN_ID",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  familyName: {
    uniField: "SPRIDEN_LAST_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  givenName: {
    uniField: "SPRIDEN_FIRST_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  otherName: {
    uniField: "SPRIDEN_MI",
    format: "TEXT",
    validationType: "STRING",
    setup: "Disabled"
  },
  phone: {
    uniField: "SPRTELE_PHONE_NUMBER",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  dob: {
    uniField: "SPBPERS_BIRTH_DATE",
    format: "DATE3",
    validationType: "DATE",
    setup: "Mandatory"
  },
  gender: {
    uniField: "SPBPERS_SEX",
    format: "GENDER",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentCompany: {
    uniField: "AGENT_COMPANY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentCompanyEmail: {
    uniField: "AGENT_COMPANY_EMAIL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentEmail: {
    uniField: "AGENT_EMAIL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentOffice: {
    uniField: "AGENT_OFFICE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchOffice: {
    uniField: "AGENT_OFFICE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  counsellorEmail: {
    uniField: "COUNSELLOR_EMAIL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  counsellorName: {
    uniField: "COUNSELLOR_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  addressLine1: {
    uniField: "SPRADDR_STREET_LINE1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  addressLine2: {
    uniField: "SPRADDR_STREET_LINE2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  addressLine3: {
    uniField: "SPRADDR_STREET_LINE3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  city: {
    uniField: "SPRADDR_CITY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentName: {
    uniField: "AGENT_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  withAgent: {
    uniField: "WITH_AGENT",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  nationality: {
    uniField: "SPRADDR_NATN_CODE",
    format: "ISO-3166-1 ALPHA-3 (Nationality)",
    validationType: "STRING",
    setup: "Secondary"
  },
  country: {
    uniField: "SPRADDR_COUNTRY",
    format: "ISO-3166-1 ALPHA-3 (Country)",
    validationType: "STRING",
    setup: "Secondary"
  },
  countryOfBirth: {
    uniField: "GOBINTL_NATN_CODE_BIRTH",
    format: "ISO-3166-1 ALPHA-3 (Country)",
    validationType: "STRING",
    setup: "Secondary"
  },
  postcode: {
    uniField: "SPRADDR_OVERSEAS_POSTCODE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  admissionsOffice: {
    uniField: "ADMISSIONS_OFFICE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Disabled"
  },
  passportNumber: {
    uniField: "GOBINTL_PASSPORT_ID",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  passportExpiry: {
    uniField: "GOBINTL_PASSPORT_EXP_DATE",
    format: "DATE3",
    validationType: "DATE",
    setup: "Secondary"
  },
  placeOfBirth: {
    uniField: "PLACE_OF_BIRTH",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  ucasId: {
    uniField: "SKRSAIN_UCASNUM",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  applicationId: {
    uniField: "SKRUCCR_APPLICANT_NO",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  englishLevelAttained: {
    uniField: "SKRICAS_SELT_LVL_ATT",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltSpeaking: {
    uniField: "SKRICAS_SELT_LVL_SPEAK",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltListening: {
    uniField: "SKRICAS_SELT_LVL_LIST",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltReading: {
    uniField: "SKRICAS_SELT_LVL_READ",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  seltWriting: {
    uniField: "SKRICAS_SELT_LVL_WRITE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  englishTestProvider: {
    uniField: "SKRICAS_SELT_TEST_PROV",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  prevUKStudy: {
    uniField: "SKRICAS_PREV_UK_STU",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  criminalConvictions: {
    uniField: "CRIMINAL_CONVICTIONS",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  previousCourseCompletion: {
    uniField: "PREVIOUS_COURSE",
    format: "DATE3",
    validationType: "DATE",
    setup: "Secondary"
  },
  applicationDate: {
    uniField: "APPLICATION_DATE",
    format: "TEXT",
    validationType: "DATE",
    setup: "Secondary"
  },
  confirmed: {
    uniField: "CONFIRMED",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_id: {
    uniField: "SORLCUR_PROGRAM",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_title: {
    uniField: "SMRPCMT_TEXT",
    format: "TEXT",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offers_courses_inner_london: {
    uniField: "CAMPUS_CODE",
    format: "NUMBER",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_cah3: {
    uniField: "COURSE_CAH3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditional: {
    uniField: "FD",
    format: "C_OR_U",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_faculty: {
    uniField: "COURSE_FACULTY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Disabled"
  },
  offers_courses_conditions_text1: {
    uniField: "COURSE_CONDITIONAL_TEXT_1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text2: {
    uniField: "COURSE_CONDITIONAL_TEXT_2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text3: {
    uniField: "COURSE_CONDITIONAL_TEXT_3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text4: {
    uniField: "COURSE_CONDITIONAL_TEXT_4",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text5: {
    uniField: "COURSE_CONDITIONAL_TEXT_5",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text6: {
    uniField: "COURSE_CONDITIONAL_TEXT_6",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text7: {
    uniField: "COURSE_CONDITIONAL_TEXT_7",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text8: {
    uniField: "COURSE_CONDITIONAL_TEXT_8",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_conditions_text9: {
    uniField: "COURSE_CONDITIONAL_TEXT_9",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_declined: {
    uniField: "AD",
    format: "D_OR_F",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_level: {
    uniField: "SZRSPMY_STAGE_LEVEL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_secondaryLevel: {
    uniField: "SECONDARY_LEVEL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_start_date: {
    uniField: "SKRICAS_VISA_START_DT",
    format: "DATE3",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offers_courses_end_date: {
    uniField: "SKRICAS_EXP_CRS_END_DT",
    format: "DATE3",
    validationType: "STRING",
    setup: "Mandatory"
  },
  offers_courses_atas: {
    uniField: "COURSE_ATAS",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_fee: {
    uniField: "SKRICAS_CRSE_FEE_FYO",
    format: "DOUBLE_COURSE_FEE",
    validationType: "STRING",
    setup: "Mandatory"
  },
  courseFeePaidToDate: {
    uniField: "SKRICAS_CRSE_FEE_PTD",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Mandatory"
  },
  offers_courses_lastAcceptanceDate: {
    uniField: "SKRICAS_LATST_ACC_DATE",
    format: "TEXT",
    validationType: "DATE",
    setup: "Secondary"
  },
  offers_courses_isFullTime: {
    uniField: "SKRUDAP_SSDT_CODE_PMOD",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  offers_courses_hoursPerWeek: {
    uniField: "HOURS_PER_WEEK",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  mainStudyAddressLine1: {
    uniField: "ADDR_STREET_LINE1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressLine2: {
    uniField: "ADDR_STREET_LINE2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressLine3: {
    uniField: "ADDR_STREET_LINE3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressCity: {
    uniField: "ADDR_CITY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressCountry: {
    uniField: "ADDR_COUNTRY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  mainStudyAddressPostcode: {
    uniField: "MN_SITE_STUDY_PO",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  isAccomProvided: {
    uniField: "SKRICAS_SPON_ACCOM_IND",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  isAccomIncludedCourseFee: {
    uniField: "SKRICAS_CRSE_FEE_INC_ACCOM_IND",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  accomFeePaidToDate: {
    format: "NUMBER",
    mappingType: "string",
    setup: "Secondary",
    uniField: "SKRICAS_ACCOM_FEE_PTD",
    validationType: "NUMBER"
  },
  isWorkPlacement: {
    uniField: "SKRICAS_APP_HS_WRK_PLMT",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  workPlacementPerc: {
    uniField: "SKRICAS_WRK_PLMT_PERCENT",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  workPlacementText: {
    uniField: "SKRICAS_WRK_PLMT_JUSTIF",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressLine1: {
    uniField: "WRK_PLMT_ADDR_1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressLine2: {
    uniField: "WRK_PLMT_ADDR_2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressLine3: {
    uniField: "WRK_PLMT_ADDR_3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressCity: {
    uniField: "WRK_PLMT_ADDR_L",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressCountry: {
    uniField: "WRK_PLMT_ADDR_C",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  workPlacementAddressPostcode: {
    uniField: "WRK_PLMT_ADDR_POST_CODE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  isSELTReqd: {
    uniField: "SKRICAS_SELT_REQ",
    format: "Y_OR_N",
    validationType: "BOOLEAN",
    setup: "Secondary"
  },
  reasonSELTNotReqd: {
    uniField: "SKRICAS_SELT_REA_NOT_REQ",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  previousCourseLevel: {
    uniField: "SKRICAS_PREV_CRS_LVL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  courseProgression: {
    uniField: "SKRICAS_PREV_CURR_LVL",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  progressionText: {
    uniField: "SKRICAS_CURR_CRS_JUST",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  docsUsedToObtainOffer: {
    uniField: "SKRICAS_DOC_OFFR",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_scholarshipTitle1: {
    uniField: "SCHOLARSHIP_TITLE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_scholarshipAmount1: {
    uniField: "SCHOLARSHIP_AMOUNT",
    format: "NUMBER",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  isPSEnglish: {
    setup: "Mandatory",
    uniField: "IS_P_S_ENGLISH",
    validationType: "BOOLEAN",
    format: "TRUE_OR_FALSE"
  },
  offers_presessional_title: {
    uniField: "Pre-sessionalTitle",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_presessional_start_date: {
    uniField: "Pre-sessionalStartDate",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_presessional_end_date: {
    uniField: "Pre-sessionalEndDate",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_presessional_fee: {
    uniField: "Pre-sessionalCourseFee",
    format: "TEXT_OR_BLANK",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_offerEvidence: {
    uniField: "offerEvidence",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_accepted: {
    uniField: "coursesAccepted",
    format: "TRUE_OR_FALSE",
    validationType: "BOOLEAN",
    setup: "Disabled"
  },
  externalCasStatus: {
    format: "TEXT",
    uniField: "offers_SMS_CAS_Status",
    validationType: "STRING",
    setup: "Secondary"
  },
  offersDurationMonths: {
    format: "NUMBER",
    uniField: "offers_duration_months",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_hecos1: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos1",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos2: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos2",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos3: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos3",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos4: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos4",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_hecos5: {
    format: "TEXT",
    uniField: "offers_courses_qual_hecos5",
    validationType: "STRING",
    setup: "Secondary"
  },
  offers_courses_qual_proportion1: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion1",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion2: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion2",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion3: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion3",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion4: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion4",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_proportion5: {
    format: "NUMBER",
    uniField: "offers_courses_qual_proportion5",
    validationType: "NUMBER",
    setup: "Secondary"
  },
  offers_courses_qual_cat: {
    format: "TEXT",
    uniField: "offers_courses_qual_cat",
    validationType: "STRING",
    setup: "Secondary"
  },
  scholarshipAmount: {
    format: "NUMBER",
    setup: "Secondary",
    uniField: "SCHOLARSHIP_AMOUNT",
    validationType: "NUMBER"
  },
  scholarshipTitle: {
    format: "TEXT",
    setup: "Secondary",
    uniField: "SCHOLARSHIP_TITLE",
    validationType: "STRING"
  },
  offers_courses_fee_discount: {
    format: "NUMBER",
    setup: "Secondary",
    uniField: "OFFERS_COURSES_FEE_DISCOUNT",
    validationType: "NUMBER"
  },
  agentFamilyName: {
    uniField: "AGENT_FAMILY_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  agentGivenName: {
    uniField: "AGENT_GIVEN_NAME",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchAddressLine1: {
    uniField: "BRANCH_ADDRESS_LINE_1",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchAddressLine2: {
    uniField: "BRANCH_ADDRESS_LINE_2",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchAddressLine3: {
    uniField: "BRANCH_ADDRESS_LINE_3",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchCity: {
    uniField: "BRANCH_CITY",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchCountry: {
    uniField: "BRANCH_COUNTRY",
    format: "ISO-3166-1 ALPHA-3 (Country)",
    validationType: "STRING",
    setup: "Secondary"
  },
  branchPostcode: {
    uniField: "BRANCH_POSTCODE",
    format: "TEXT",
    validationType: "STRING",
    setup: "Secondary"
  }
});

// src/uni-config-mappingTypes.ts
function deepFreeze4(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze4(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultMappingTypes = deepFreeze4({
  MAP_DEFAULT_FALSE: {
    default: false
  },
  MAP_DEFAULT_TRUE: {
    default: true
  },
  MAP_OFFER_ID_UNKNOWN: {
    default: "1"
  }
});

// src/uni-config-reminderNotifications.ts
import { EmailTemplates, ApplicantReminderEmailTemplates } from "platform-types";
function deepFreeze5(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze5(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var reminderNotificationsConfig = deepFreeze5({
  emails: {
    [EmailTemplates.WELCOME]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.CAS_BYPASS_WELCOME]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.STUDENT_DETAILS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.HISTORY]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.FINANCE]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.OUTSTANDING_DOCUMENTS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.OUTSTANDING_FOLLOWUP_DOCUMENTS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.PRECAS_INTERVIEW]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.INTERVIEWS]: { repeat: 7, initialDelay: 4 },
    [EmailTemplates.PASSPORT]: {},
    [EmailTemplates.DEPOSIT]: {},
    [EmailTemplates.VISA_1]: { repeat: 7, initialDelay: 2 },
    [EmailTemplates.VISA_1_LATE]: { repeat: 7, initialDelay: 2 },
    [EmailTemplates.VISA_2]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.VISA_2_LATE]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.ARRIVAL_1]: { repeat: 7, initialDelay: 1 },
    [EmailTemplates.ARRIVAL_2]: { repeat: 7, initialDelay: 7 },
    [EmailTemplates.ARRIVAL_3]: { initialDelay: 7 },
    [EmailTemplates.ARRIVAL_4]: { initialDelay: 1 },
    [EmailTemplates.NEW_INTERVIEWS]: { initialDelay: 1 },
    [EmailTemplates.READY_FOR_CAS]: { initialDelay: 1 },
    [EmailTemplates.DEFERRAL]: { initialDelay: 1 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_2]: { initialDelay: 4 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_3]: { initialDelay: 8 },
    [ApplicantReminderEmailTemplates.VERIFY_REMINDER_4]: { initialDelay: 13 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.REGISTER_INTEREST_4]: { initialDelay: 30 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.START_APPLICATION_4]: { initialDelay: 30, repeat: 30 },
    // repeat every 1 month = every 30 days
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.CONTINUE_APPLICATION_4]: { initialDelay: 30, repeat: 30 },
    // repeat every 1 month = every 30 days
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.SUBMIT_APPLICATION_4]: { initialDelay: 30, repeat: 30 },
    // repeat every 1 month = every 30 days
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_2]: { initialDelay: 7 },
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_3]: { initialDelay: 14 },
    [ApplicantReminderEmailTemplates.UPDATE_PROGRAMME_CHOICES_4]: { initialDelay: 30 },
    [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.ACCEPT_YOUR_OFFER_2]: { initialDelay: 7, repeat: 7 },
    [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.SATISFY_OFFER_CONDITION_2]: { initialDelay: 7, repeat: 7 },
    [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_1]: { initialDelay: 2 },
    [ApplicantReminderEmailTemplates.CONFIRM_PAYMENT_2]: { initialDelay: 7, repeat: 7 }
  }
});

// src/uni-config.ts
function deepFreeze6(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze6(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var stages = [
  CoreStatus.PRE_DEPOSIT,
  CoreStatus.POST_DEPOSIT,
  CoreStatus.READY_FOR_CAS,
  CoreStatus.CAS_ISSUED,
  CoreStatus.VISA_ISSUED,
  CoreStatus.VISA_REFUSED,
  CoreStatus.DEFERRED,
  CoreStatus.CLOSED_LOST
];
var moveToStages = [
  { key: CoreStatus.PRE_DEPOSIT, label: CoreStatus.PRE_DEPOSIT },
  { key: CoreStatus.POST_DEPOSIT, label: CoreStatus.POST_DEPOSIT },
  { key: CoreStatus.READY_FOR_CAS, label: CoreStatus.READY_FOR_CAS },
  { key: CoreStatus.CAS_ISSUED, label: CoreStatus.CAS_ISSUED },
  { key: CoreStatus.VISA_ISSUED, label: CoreStatus.VISA_ISSUED },
  { key: CoreStatus.VISA_REFUSED, label: CoreStatus.VISA_REFUSED },
  { key: CoreStatus.DEFERRED, label: CoreStatus.DEFERRED },
  { key: CoreStatus.CLOSED_LOST, label: CoreStatus.CLOSED_LOST }
];
var uniStages = [
  CoreStatusExtended.PRE_DEPOSIT,
  CoreStatusExtended.POST_DEPOSIT,
  CoreStatusExtended.READY_FOR_CAS,
  CoreStatusExtended.CAS_ISSUED,
  CoreStatusExtended.VISA_ISSUED,
  CoreStatusExtended.VISA_REFUSED,
  CoreStatusExtended.DEFERRED,
  CoreStatusExtended.CLOSED_LOST
];
var uniMoveToStages = [
  { key: CoreStatusExtended.PRE_DEPOSIT, label: CoreStatusExtended.PRE_DEPOSIT },
  { key: CoreStatusExtended.POST_DEPOSIT, label: CoreStatusExtended.POST_DEPOSIT },
  { key: CoreStatusExtended.READY_FOR_CAS, label: CoreStatusExtended.READY_FOR_CAS },
  { key: CoreStatusExtended.CAS_ISSUED, label: CoreStatusExtended.CAS_ISSUED },
  { key: CoreStatusExtended.VISA_ISSUED, label: CoreStatusExtended.VISA_ISSUED },
  { key: CoreStatusExtended.VISA_REFUSED, label: CoreStatusExtended.VISA_REFUSED },
  { key: CoreStatusExtended.DEFERRED, label: CoreStatusExtended.DEFERRED },
  { key: CoreStatusExtended.CLOSED_LOST, label: CoreStatusExtended.CLOSED_LOST }
];
var config = {
  urls: {
    Partners: {},
    ImmigrationProviders: {}
  },
  roles: [],
  accessKey: "",
  enrolyAccess: "",
  documentDownloads: {
    enabled: false,
    errorMessage: ""
  },
  offerEnabled: false,
  intakeIds: [],
  defaultIntakeId: "all",
  universityIds: [],
  partnerIds: [],
  allPartners: [],
  allImmigrationProviders: [],
  stages: [...uniStages],
  moveToStages: [...uniMoveToStages],
  dashboardTabs: {
    "[UniAdmin]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Uni]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isArrStatusVisible: true,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[UniSecure]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[UniLite]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isArrStatusVisible: true,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Partner]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [
          CoreStatusExtended.POST_DEPOSIT,
          CoreStatusExtended.INTERVIEW,
          CoreStatusExtended.COMPLIANCE_CHECK,
          CoreStatusExtended.PATHWAY_REVIEW,
          CoreStatusExtended.AWAITING_INFO
        ],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[ImmigrationProvider]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [
          CoreStatusExtended.POST_DEPOSIT,
          CoreStatusExtended.INTERVIEW,
          CoreStatusExtended.COMPLIANCE_CHECK,
          CoreStatusExtended.PATHWAY_REVIEW,
          CoreStatusExtended.AWAITING_INFO
        ],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Agent]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Admin]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 155,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 155,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Not Triggered",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Not-Triggered"],
        isFollowUpDocsCountVisible: false,
        id: "Not-Triggered",
        isVisaStatusVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Waiting for Intake",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Waiting for Intake"],
        isFollowUpDocsCountVisible: false,
        id: "Waiting for Intake",
        isVisaStatusVisible: false
      }
    ],
    "[AgencyAdmin]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: true
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      }
    ],
    "[Enroly]": [
      {
        id: "Pre-Deposit",
        label: "Pre-Deposit",
        statuses: [CoreStatusExtended.PRE_DEPOSIT],
        color: "#cef6ff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Post-Deposit",
        label: "Post-Deposit",
        statuses: [CoreStatusExtended.POST_DEPOSIT],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Ready for CAS",
        label: "Ready for CAS",
        statuses: [CoreStatusExtended.READY_FOR_CAS],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: false,
        isDocsCountVisible: true,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: true,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "CAS Issued",
        label: "CAS Issued",
        statuses: [CoreStatusExtended.CAS_ISSUED],
        color: "#eafbff",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Visa Issued",
        label: "Visa Issued",
        statuses: [CoreStatusExtended.VISA_ISSUED],
        color: "#f0fff6",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: true,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: true,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Visa Refused",
        label: "Visa Refused",
        statuses: [CoreStatusExtended.VISA_REFUSED],
        color: "#fff2eb",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: true,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: false,
        isDepositDateVisible: false
      },
      {
        id: "Deferred",
        label: "Deferred",
        statuses: [CoreStatusExtended.DEFERRED],
        color: "#eaeaea",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        id: "Closed Lost",
        label: "Closed Lost",
        statuses: [CoreStatusExtended.CLOSED_LOST],
        color: "#d1d1d1",
        width: 175,
        isVisaStatusVisible: true,
        isDocsCountVisible: false,
        isArrStatusVisible: false,
        isFollowUpDocsCountVisible: false,
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isFundsMatVisible: true,
        isDepositDateVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Not Triggered",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Not-Triggered"],
        isFollowUpDocsCountVisible: false,
        id: "Not-Triggered",
        isVisaStatusVisible: false
      },
      {
        isArrStatusVisible: false,
        isFundsMatVisible: true,
        color: "#cef6ff",
        isDepositDateVisible: true,
        isNotInvited: true,
        label: "Waiting for Intake",
        isAgentDocsCountVisible: false,
        isConditionalStatusVisible: false,
        isDocsCountVisible: true,
        width: 107,
        statuses: ["Waiting for Intake"],
        isFollowUpDocsCountVisible: false,
        id: "Waiting for Intake",
        isVisaStatusVisible: false
      }
    ]
  },
  mappingTypes: defaultMappingTypes,
  setupTypes: ["Mandatory", "Secondary", "Disabled"],
  formatTypes: defaultFormatTypes,
  importFieldMappings: defaultFieldMappings,
  sftpImportFieldMappings: defaultFieldMappings,
  sponsor: {
    licenceNumber: "",
    schoolName: "",
    address: "",
    city: "",
    postcode: ""
  },
  defaultUniversityId: "STG",
  university_name: "Staging",
  university_code: "STG",
  teamName: "CAS team",
  documentDownloadsActive: false,
  tuitionPostDiscount: false,
  campuses: [],
  faculties: [],
  departments: [],
  categories: [],
  visaStatuses: [
    "None",
    "CAS not received",
    "CAS received",
    "Visa applied",
    "Awaiting visa response",
    "UKVI request more info",
    "Visa received",
    "Visa refusal",
    "Intends to defer",
    "Intends to withdraw"
  ],
  accessToken: "",
  apiEndpointUrl: "https://public-dev-api.cas-shield.com",
  resolveConflictsModalText: "This action does not update your university system. Please ensure your central records are up to date.",
  defaultQuestions: [],
  trapQuestions: [],
  reminderNotifications: reminderNotificationsConfig,
  applyEnabled: false,
  apply: {
    studentNumberEnabled: false
  },
  partialApplyJourney: false,
  allowedAliases: []
};
var defaultUniConfig = deepFreeze6({ ...config });
var defaultImmigrationProviderConfig = deepFreeze6({
  ...config,
  moveToStages,
  stages
});
var defaultEmailFrom = deepFreeze6({
  casShieldEmailFrom: '"CAS Shield" <contact@cas-shield.com>',
  applyEmailFrom: '"Enroly Apply" <contact@enroly.com>'
});
export {
  SHARE_CODE_EXPIRY_ALERT_DAYS_DEFAULT,
  SHARE_CODE_EXPIRY_DAYS_DEFAULT,
  defaultEmailFrom,
  defaultFormatTypes,
  defaultImmigrationProviderConfig,
  defaultUniConfig,
  defaultnoRoleAssignedMsg,
  officeSelectionFields,
  reminderNotificationsConfig,
  universityKeys
};
